import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";

// components

import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import HeaderStats from "components/Headers/HeaderStats.js";
import FooterAdmin from "components/Footers/FooterAdmin.js";

// views

import Dashboard from "views/admin/Dashboard.js";
import Clients from "views/admin/Clients.js";
import Analytics from "views/admin/Analytics.js";
import AddAnalytics from "views/admin/AddAnalytics.js";

import Accounts from "views/admin/Accounts.js";
import Invoices from "views/admin/Invoices.js";
import Websites from "views/admin/Websites.js";
import AddAccounts from "views/admin/AddAccounts";
import AddClients from "views/admin/AddClients";
import AddWebsites from "views/admin/AddWebsites";
import AddInvoices from "views/admin/AddInvoices";

import Maps from "views/admin/Maps.js";
import Settings from "views/admin/Settings.js";
import Tables from "views/admin/Tables.js";
import { isModuleAllowed } from "config/roles";

export default function Admin() {
  return (
    <>
      <Sidebar />
      <div className="relative md:ml-64 bg-blueGray-100 h-screen">
        <AdminNavbar />
        {/* Header */}
        <HeaderStats />
        <div className="px-4 md:px-10 mx-auto w-full  -m-16">
          <Switch>
            <Route path="/admin/dashboard" exact component={Dashboard} />
          
            <Route path="/admin/client" exact component={Clients} />
            <Route path="/admin/add-client" exact component={AddClients} />
            <Route path="/admin/update-client" exact component={AddClients} />

            <Route path="/admin/analytics" exact component={Analytics} />
            <Route path="/admin/add-analytic" exact component={AddAnalytics} />
            <Route path="/admin/update-analytic" exact component={AddAnalytics} />

            <Route path="/admin/accounts" exact component={Accounts} />
            <Route path="/admin/add-account" exact component={AddAccounts} />
            <Route path="/admin/update-account" exact component={AddAccounts} />


            <Route path="/admin/invoices" exact component={Invoices} />
            <Route path="/admin/add-invoice" exact component={AddInvoices} />
            <Route path="/admin/update-invoice" exact component={AddInvoices} />


            <Route path="/admin/websites" exact component={Websites} />
            <Route path="/admin/add-website" exact component={AddWebsites} />
            <Route path="/admin/update-website" exact component={AddWebsites} />

            <Route path="/admin/maps" exact component={Maps} />
            <Route path="/admin/settings" exact component={Settings} />
            <Route path="/admin/tables" exact component={Tables} />
            <Redirect from="/admin" to="/admin/dashboard" />
          </Switch>
          <FooterAdmin />
        </div>
      </div>
    </>
  );
}
